module.exports = __webpack_public_path__ + "promo/app-store-badges/google-play-store-es-272a57ff9af3fe618b9e83572f0fbf79.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/google-play-store-es.svg
// module id = cw5c
// module chunks = 23